<template>
  <div>
    <!--  -->
    <h2>選択ボックス</h2>
    <p>選択ボックスもv-modelディレクティブを指定することで双方向データバインディングが行えます。<br />
        デフォルトでは、選択したoption要素のコンテンツ部分の値が戻されます。</p>
    <pre v-pre>
        <code>
[html]
&lt;select v-model=&quot;age&quot;&gt;&#10;  &lt;option disabled value=&quot;&quot;&gt;&#24180;&#40802;&#65311;&lt;/option&gt;&#10;  &lt;option&gt;3&#27507;&#26410;&#28288;&lt;/option&gt;&#10;  &lt;option&gt;13&#27507;&#26410;&#28288;&lt;/option&gt;&#10;  &lt;option&gt;65&#27507;&#26410;&#28288;&lt;/option&gt;&#10;  &lt;option&gt;65&#27507;&#20197;&#19978;&lt;/option&gt;&#10;&lt;/select&gt;&#10;&lt;br /&gt;&#10;&lt;p v-if=&quot;fare &gt;= 0&quot;&gt;{{ fare }}&lt;/p&gt;

[js]
data: {
  age: ''
},
computed: {
  fare: function() {
    console.log(this.age);
    if(this.age == '3歳未満') {
      return 0;
    } else if (this.age == '13歳未満') {
      return 1000;
    } else if (this.age == '65歳未満') {
      return 2000;
    } else if (this.age == '65歳以上') {
      return 0;
    } else {
      return -1;
    }
  }
}
        </code>
    </pre>
<select v-model="age">
  <option disabled value="">年齢？</option>
  <option>3歳未満</option>
  <option>13歳未満</option>
  <option>65歳未満</option>
  <option>65歳以上</option>
</select>
<br />
<p v-if="fare >= 0">{{ fare }}</p>
<!--  -->
<h2>複数要素を選択可能な選択ボックス</h2>
<p>select要素にmultiple属性を設定すると、複数の項目を選択可能な選択ボックスとなります。この場合、戻される値は配列となります。</p>
<pre v-pre>
  <code>
[html]
&lt;select v-model=&quot;countries&quot; multiple&gt;&#10;  &lt;option&gt;&#12452;&#12462;&#12522;&#12473;&lt;/option&gt;&#10;  &lt;option value=&quot;USA&quot;&gt;&#12450;&#12513;&#12522;&#12459;&lt;/option&gt;&#10;  &lt;option&gt;&#20013;&#22269;&lt;/option&gt;&#10;  &lt;option&gt;&#12473;&#12506;&#12452;&#12531;&lt;/option&gt;&#10;&lt;/select&gt;&#10;&lt;br /&gt;&#10;&lt;button v-on:click=&quot;countries=[]&quot;&gt;&#12463;&#12522;&#12450;&lt;/button&gt;&#10;&lt;ul&gt;&#10;  &lt;li v-for=&quot;c in countries&quot;&gt;{{ c }}&lt;/li&gt;&#10;&lt;/ul&gt;

[js]
data: {
  countries: []
}
  </code>
</pre>
<select v-model="countries" multiple>
  <option>イギリス</option>
  <option value="USA">アメリカ</option>
  <option>中国</option>
  <option>スペイン</option>
</select>
<br />
<button v-on:click="countries=[]">クリア</button>
<ul>
  <li v-for="(c, i) in countries" :key="i">{{ c }}</li>
</ul>
<!--  -->
<h2>v-forでラジオボタンや選択ボックスのオプションを動的に用意する</h2>
<p v-pre>ラジオボタンや選択ボックスなどで複数の選択項目を動的に描画するには、v-forディレクティブが使用できます。以下は選択ボックスの例です</p>
<pre v-pre>
  <code>
[html]
&lt;select v-modle=&quot;countries&quot; multiple&gt;&#10;  &lt;option v-for=&quot;c in clist&quot; v-bind:value=&quot;c.en&quot;&gt;{{ c.ja }}&lt;/option&gt;&#10;&lt;/select&gt;&#10;&lt;br /&gt;&#10;&lt;button v-on:click=&quot;countries=[]&quot;&gt;&#12463;&#12522;&#12450;&lt;/button&gt;&#10;&lt;ul&gt;&#10;  &lt;li v-for=&quot;c in countries&quot;&gt;{{ c }}&lt;/li&gt;&#10;&lt;/ul&gt;

[js]
data: {
  clist: [
    { en:'ENGLAND', ja:'イングランド'},
    { en:'USA', ja:'アメリカ'},
    { en:'CHINA', ja:'中国'},
    { en:'SPAIN', ja:'スペイン'},
    { en:'JAPAN', ja:'日本'}
  ],
  countries: []
}
  </code>
</pre>
<p>行ってみたい国は？</p>
<select v-model="countries" multiple>
  <option v-for="(c, i) in clist" v-bind:value="c.en" :key="i">{{ c.ja }}</option>
</select>
<br />
<button v-on:click="countries=[]">クリア</button>
<ul>
  <li v-for="(c, i) in countries" :key="i">{{ c }}</li>
</ul>
<!--  -->
<h3>チェックボックスの場合</h3>
<pre v-pre>
  <code>
&lt;div v-for=&quot;c in clist&quot;&gt;&#10;  &lt;input type=&quot;checkbox&quot; :value=&quot;c.en&quot; :id=&quot;c.en&quot; v-model=&quot;countries&quot;&gt;&#10;  &lt;label v-bind:for=&quot;c.en&quot;&gt;{{ c.ja }}&lt;/label&gt;&#10;&lt;/div&gt;&#10;&lt;br /&gt;&#10;&lt;button v-on:click=&quot;countries=[]&quot;&gt;&#12463;&#12522;&#12450;&lt;/button&gt;&#10;&lt;ul&gt;&#10;  &lt;li v-for=&quot;c in countries&quot;&gt;{{ c }}&lt;/li&gt;&#10;&lt;/ul&gt;
  </code>
</pre>
  <div v-for="(c, i) in clist" :key="i">
    <input type="checkbox" :value="c.en" :id="c.en" v-model="countries">
    <label v-bind:for="c.en">{{ c.ja }}</label>
  </div>
<br />
<button v-on:click="countries=[]">クリア</button>
<ul>
  <li v-for="(c, i) in countries" :key="i">{{ c }}</li>
</ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        age: '',
        countries: [],
        clist: [
          { en:'ENGLAND', ja:'イングランド'},
          { en:'USA', ja:'アメリカ'},
          { en:'CHINA', ja:'中国'},
          { en:'SPAIN', ja:'スペイン'},
          { en:'JAPAN', ja:'日本'}
        ]
      }
    },
    computed: {
      fare: function() {
        let val = this;
        if(val.age == '3歳未満') {
          return 0;
        } else if (val.age == '13歳未満') {
          return 1000;
        } else if (val.age == '65歳未満') {
          return 2000;
        } else if (val.age == '65歳以上') {
          return 0;
        } else {
          return -1;
        }
      }
    }
  }
</script>